import { gql } from '@apollo/client';

export const FETCH_WAITLIST_OPTIONS = gql`
  query Flex_FetchWaitlistOptions($utilityId: Int!) {
    utility(id: $utilityId) {
      funnelTrack
      isutilityScraperEligible
    }
  }
`;
